import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Lightbox } from "ngx-lightbox/lightbox.service";
import { c1, c3, c4, offcanvasColors } from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { Menu, MenuButton, Tab } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { BuilderService } from "src/app/sharedservices/builder.service";

@Component({
  selector: "app-gen-menu-bg-color-component",
  templateUrl: "./gen-menu-bg-color-component.component.html",
  styleUrls: ["./gen-menu-bg-color-component.component.scss"],
})
export class GenMenuBgColorComponent implements OnInit, OnDestroy {
  constructor(
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    private modalService: BsModalService,
    private builderService: BuilderService,
    private lightbox: Lightbox
  ) {}

  @Input() menu_id: string;
  @Input() config: any;

  imageConfig: any = {};
  imageDarkConfig: any = {};
  bgimage: string = null;

  page: any;
  c4_value: string;
  c5_value: string;
  c3_value: string;
  offCanvasSubscription: any;
  albums = [];
  title: string;
  offcanvasColors = offcanvasColors;
  enableNav: boolean;
  singleTab: string = c3.SINGLE;
  mode: string;

  currentMenuSubscription: any;
  colorsComponentSubscription: any;
  menu: Menu;
  data: any;
  sync = true;
  isAndroid: boolean = false;
  toggleDarkImage = false;
  enableCustomGradientColor: boolean = false;

  off_canvas_key: string = "gen";

  startColor: string;
  startDarkColor: string;
  endColor: string;
  endDarkColor: string;
  labelDarkColor: any;
  light: any;
  colors: any;
  allColors: any;

  ngOnInit() {
    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "gen" &&
          data.menu_id == this.menu_id
        ) {
        }
      }
    );

    this.currentMenuSubscription = this.mdw.currentMenuContainer$.subscribe(
      (data) => {
        if (data && data.menu && data.menu.menu_id == this.menu_id) {
          this.menu = data.menu;
          this.data = data;
          this.allColors = data.colors;
          this.menuFunction();
        }
      }
    );

    this.colorsComponentSubscription =
      this.mdw.colorsComponentContainer$.subscribe((data) => {
        if (
          data &&
          data.color_schema &&
          data.color_schema_ios &&
          data.light != null
        ) {
          this.light = data.light;
        }
      });
  }

  menuFunction() {
    if (this.menu) {
      this.isAndroid = localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;
      this.colors = this.isAndroid
        ? this.allColors.color_schema
        : this.allColors.color_schema_ios;

      if (this.isAndroid) {
        if(this.menu.menu_bg && this.menu.menu_bg.start && this.menu.menu_bg.end && this.menu.menu_bg.start_dark && this.menu.menu_bg.end_dark){
          this.startColor = this.menu.menu_bg.start;
          this.startDarkColor = this.menu.menu_bg.start_dark;
          this.endColor = this.menu.menu_bg.end;
          this.endDarkColor = this.menu.menu_bg.end_dark;
          this.enableCustomGradientColor = true;
        }else{
          this.enableCustomGradientColor = false;
        }
      } else {
        if(this.menu.menu_bg_ios && this.menu.menu_bg_ios.start && this.menu.menu_bg_ios.end && this.menu.menu_bg_ios.start_dark && this.menu.menu_bg_ios.end_dark){
          this.startColor = this.menu.menu_bg_ios.start;
          this.startDarkColor = this.menu.menu_bg_ios.start_dark;
          this.endColor = this.menu.menu_bg_ios.end;
          this.endDarkColor = this.menu.menu_bg_ios.end_dark;
          this.enableCustomGradientColor = true;
        }else{
          this.enableCustomGradientColor = false;
        }
      }
    }
  }

  toggleGradientColor(event) {
    this.enableCustomGradientColor = event;

    if (this.isAndroid || this.sync) {
      if (this.enableCustomGradientColor) {
        this.startColor = this.colors.schemes.light[this.config.init_start];
        this.startDarkColor = this.colors.schemes.dark[this.config.init_start];
        this.endColor = this.colors.schemes.light[this.config.init_end];
        this.endDarkColor = this.colors.schemes.dark[this.config.init_end];
        this.menu = {
          ...this.menu,
          menu_bg: {
            ...this.menu.menu_bg,
            start: this.startColor,
            end: this.endColor,
            start_dark: this.startDarkColor,
            end_dark: this.endDarkColor,
          },
        };
      } else {
        this.startColor = null;
        this.labelDarkColor = null;
        this.endColor = null;
        this.endDarkColor = null;
        delete this.menu.menu_bg.start;
        delete this.menu.menu_bg.end;
        delete this.menu.menu_bg.start_dark;
        delete this.menu.menu_bg.end_dark;

      if (Object.keys(this.menu.menu_bg).length == 0) {
       delete this.menu.menu_bg;
      }
    }
    }

    if (!this.isAndroid || this.sync) {
      if (this.enableCustomGradientColor) {
        this.startColor = this.colors.schemes.light[this.config.init_start_ios];
        this.startDarkColor = this.colors.schemes.dark[this.config.init_start_ios];
        this.endColor = this.colors.schemes.light[this.config.init_end_ios];
        this.endDarkColor = this.colors.schemes.dark[this.config.init_end_ios];
        this.menu = {
          ...this.menu,
          menu_bg_ios: {
            ...this.menu.menu_bg_ios,
            start: this.startColor,
            end: this.endColor,
            start_dark: this.startDarkColor,
            end_dark: this.endDarkColor,
          },
        };
      } else {
        this.startColor = null;
        this.labelDarkColor = null;
        this.endColor = null;
        this.endDarkColor = null;
        delete this.menu.menu_bg_ios.start;
        delete this.menu.menu_bg_ios.end;
        delete this.menu.menu_bg_ios.start_dark;
        delete this.menu.menu_bg_ios.end_dark;

     if (Object.keys(this.menu.menu_bg_ios).length == 0) {
        delete this.menu.menu_bg_ios;
      }

      }
    }
    this.updateMenuData();
  }

  startColorChange(value, manual, mode = "color") {
    let color = null;
    let onMode: string;
    if (mode == "color") {
      onMode = "colorContainer";
    } else {
      onMode = "color";
    }
    color =
      manual == true
        ? this.mdw.isValidHexaCode(value.target.value)
          ? value.target.value
          : null
        : value;
    if (color) {
      this.isAndroid = localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;
      this.colors = this.isAndroid ? this.allColors.color_schema : this.allColors.color_schema_ios;
      let customColor = this.mdw.customColor(color, this.colors.source);
      let onCustomColor = this.mdw.customColor(
        color,
        this.colors.source,
        onMode
      );
      this.startColor = customColor.light;
      this.startDarkColor = customColor.dark;
      this.endColor = onCustomColor.light;
      this.endDarkColor = onCustomColor.dark;

      if (this.isAndroid || this.sync) {
        this.menu.menu_bg.start = this.startColor;
        this.menu.menu_bg.start_dark = this.startDarkColor;
      }
      if (!this.isAndroid || this.sync) {
        this.menu.menu_bg_ios.start = this.startColor;
        this.menu.menu_bg_ios.start_dark = this.startDarkColor;
      }
      if (this.isAndroid || this.sync) {
        this.menu.menu_bg.end = this.endColor;
        this.menu.menu_bg.end_dark = this.endDarkColor;
      }
      if (!this.isAndroid || this.sync) {
        this.menu.menu_bg_ios.end = this.endColor;
        this.menu.menu_bg_ios.end_dark = this.endDarkColor;
      }
      this.updateMenuData();
    }
  }

  endColorChange(value, manual, mode = "color") {
    let color = null;
    let onMode: string;
    if (mode == "color") {
      onMode = "colorContainer";
    } else {
      onMode = "color";
    }
    color = manual == true ? this.mdw.isValidHexaCode(value.target.value) ? value.target.value : null : value;
    if (color) {
      this.isAndroid = localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;
      this.colors = this.isAndroid ? this.allColors.color_schema : this.allColors.color_schema_ios;
      let customColor = this.mdw.customColor(color, this.colors.source);
      let onCustomColor = this.mdw.customColor(color, this.colors.source, onMode);
      this.endColor = customColor.light;
      this.endDarkColor = customColor.dark;
      this.startColor = onCustomColor.light;
      this.startDarkColor = onCustomColor.dark;

      if (this.isAndroid || this.sync) {
        this.menu.menu_bg.end = this.endColor;
        this.menu.menu_bg.end_dark = this.endDarkColor;
      }
      if (!this.isAndroid || this.sync) {
        this.menu.menu_bg_ios.end = this.endColor;
        this.menu.menu_bg_ios.end_dark = this.endDarkColor;
      }
      if (this.isAndroid || this.sync) {
        this.menu.menu_bg.start = this.startColor;
        this.menu.menu_bg.start_dark = this.startDarkColor;
      }
      if (!this.isAndroid || this.sync) {
        this.menu.menu_bg_ios.start = this.startColor;
        this.menu.menu_bg_ios.start_dark = this.startDarkColor;
      }
      this.updateMenuData();
    }
  }

  updateMenuData() {
    //*must be there in all buttons
    // this.buttonList[this.button_id] = this.button;
    // let index = this.sortedButtonList[this.button.row_id].findIndex(
    //   (e) => e.button_id == this.button_id
    // );
    // this.sortedButtonList[this.button.row_id][index] = { ...this.button };
    // this.data["sortedButtonList"] = this.sortedButtonList;
    // this.data["buttonList"] = this.buttonList;
    this.data["off_canvas_key"] = this.off_canvas_key;
    this.data["menu"] = this.menu;
    let index = this.data['sortedMenuList'].findIndex((e) => e.menu_id == this.menu.menu_id);
    this.data['sortedMenuList'][index]=this.menu
    this.data['menuList'][this.menu.menu_id] = this.menu;

    this.mdw._currentMenuContainer.next(this.data);

    this.mdw.changeTab(
      { menu: this.menu, tab: { module: "menu" } },
      this.mode,
      true
    );
  }
  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
    if (this.currentMenuSubscription) {
      this.currentMenuSubscription.unsubscribe();
    }
    if (this.colorsComponentSubscription) {
      this.colorsComponentSubscription.unsubscribe();
    }
  }
}
